import { call, put, takeEvery } from 'redux-saga/effects';
import { searchBikesByBrand } from '../../requests/search_by_brand_request';
import { searchBikeModel, countBikeModels } from '../../requests/search_bike_model_request';
import { searchBikeRequestSuccess, searchBikeRequestFailure } from '../actions/search_bike.actions';
import { SEARCH_BIKE_REQUEST } from '../constants/bike_model.constants';
import { countBikeModelsRequestFailure, countBikeModelsRequestSuccess } from '../actions/count_bike_models.actions';

function* searchBikeSagaRequest({ payload }) {
    const brands = yield call(searchBikesByBrand, payload);
    const ids = brands.map(({ _id }) => _id);
    const models = yield call(searchBikeModel, payload, ids);
    if (models.length) {
        if (models.length === 1) {
            // history.push(`/PlatformManagement/Bike_model_update/${models[0]._id}`);
        } else {
            yield put(searchBikeRequestSuccess(models));
            const response = yield call(countBikeModels, payload, ids);
            response.result
                ? yield put(countBikeModelsRequestSuccess(response.options.amount))
                : yield put(countBikeModelsRequestFailure('Cannot count all models!'));
        }
    } else {
        yield put(searchBikeRequestFailure('error'));
    }
}

export default function* searchBikeSaga() {
    yield takeEvery(SEARCH_BIKE_REQUEST, searchBikeSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/sagas/search_bike.saga.js